import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../home/redux/actions';
import Header from './HeaderLayout';
import { Row, Col } from 'antd';
import Footer from './Footer';
import RichTextEditor from 'react-rte';

export class Cgu extends Component {
  static propTypes = {

  };

  componentDidMount(){
    this.props.actions.getConfig();
  }

  render() {
    return (
      <div>
        <Header/>
        <div className="others-cgu">
          <Row>
            <Col>
              <h1>conditions générales d'utilisation</h1>
              <RichTextEditor 
                  value={RichTextEditor.createValueFromString( this.props.home.config.termsOfUsage, 'html')}
                  readOnly
                  />
            </Col>
          </Row>
        </div>
        <Footer/>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Cgu);


// WEBPACK FOOTER //
// ./src/features/others/Cgu.js